import { useTranslation } from "react-i18next";
import { categories } from "@/data/categories";

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
      {categories.map((cat) => (
        <a
          key={cat.key}
          href={cat.url}
          target="_blank"
          rel="noopener nofollow"
          className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition hover:-translate-y-0.5 hover:border-primary-300"
        >
          <div className="relative h-32 w-full overflow-hidden sm:h-36">
            <img
              src={cat.image}
              alt={t(`cat.${cat.key}`)}
              title={`${t(`cat.${cat.key}`)} — ${t("brand.name")}`}
              className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
            />
          </div>
          <div className="flex items-center justify-between gap-2 px-3 py-3">
            <span className="truncate text-sm font-semibold text-foreground-900">
              {t(`cat.${cat.key}`)}
            </span>
            <i className="ri-arrow-right-up-line text-sm text-primary-600"></i>
          </div>
        </a>
      ))}
    </div>
  );
}